
const links = document.querySelectorAll(".quick-links a");
const orangeButton = document.querySelector(".hero-banner a.orange-button")
// const privacySectionLinks = document.querySelectorAll("#privacySections a.orange-line")

var root = $('html, body');

for (const link of links) {
  link.addEventListener("click", clickHandler);
}


orangeButton && orangeButton.addEventListener("click", clickHandler);


// for (const privacySectionLink of privacySectionLinks) {
//   privacySectionLink.addEventListener("click", clickHandler);
// }

function clickHandler(e) {

  const href = e.target.getAttribute("href");
  const headerHeight = window.screen.width < 992 ? 66 : 85;

  //jquery
  root.animate({
      scrollTop: $(href).offset().top - headerHeight
  }, 500, function () {
      window.location.hash = href;
  });

  return false;


}
